import { Box, Link, Typography, makeStyles } from '@material-ui/core';
import { MdEdit } from 'react-icons/md';
import { RespostasI } from '../../interfaces/form-flow';
import { getDocumentosPendentesAssinatura } from '../../utils/documentosAssinatura';

const useStyles = makeStyles(() => ({
  alertBox: {
    margin: '20px 0',
    padding: '16px 20px',
    borderRadius: 8,
    border: '2px solid #E53535',
    backgroundColor: 'rgba(229, 53, 53, 0.08)',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
  },
  icon: {
    color: '#E53535',
    fontSize: 24,
    flexShrink: 0,
    marginTop: 2,
  },
  message: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 500,
    color: '#373F41',
    lineHeight: 1.5,
  },
  actionLink: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 700,
    color: '#0F6FB7',
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: 0,
    verticalAlign: 'baseline',
    '&:hover': {
      color: '#0a5a94',
    },
  },
}));

type Props = {
  request: RespostasI;
  signedDocumentIds?: Set<string>;
  onAssinarClick: () => void;
  validating?: boolean;
  sectionId?: string;
};

export default function DocumentosParaAssinaturaSection({
  request,
  signedDocumentIds = new Set(),
  onAssinarClick,
  validating = false,
  sectionId,
}: Props): JSX.Element | null {
  const classes = useStyles();
  const pendentes = getDocumentosPendentesAssinatura(request, signedDocumentIds);

  if (pendentes.length === 0) {
    return null;
  }

  const mensagem =
    pendentes.length === 1
      ? 'Você tem um documento para assinar.'
      : `Você tem ${pendentes.length} documentos para assinar.`;

  return (
    <Box id={sectionId} className={classes.alertBox} role='alert'>
      <MdEdit className={classes.icon} aria-hidden />
      <Typography className={classes.message} component='p'>
        {mensagem}{' '}
        <Link
          component='button'
          type='button'
          className={classes.actionLink}
          onClick={onAssinarClick}
          disabled={validating}
        >
          {validating ? 'Verificando...' : 'Clique Aqui'}
        </Link>
      </Typography>
    </Box>
  );
}
